import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Figure, Form, Modal, Row } from "react-bootstrap";
import {
  addAndUpdateEmployment,
  addAndUpdateTeam,
  addAndUpdateUser,
} from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { MaxLength } from "../../../utils/constants/CharactersLength";
import { ValidationMessage } from "../../../utils/constants/validationMessage";
import { integerInput, whiteSpaceCheck } from "../../../helper/helper";
import { Loader } from "lucide-react";
import { BASE_URL } from "../../../services/path";
import AuthContext from "../../../hooks/context/AuthContext";
import PhoneInputField from "../../../components/shared/FormFields/PhoneInputField";
import { regex } from "../../../utils/constants/regexVariables";

const AddEdit = ({
  show,
  onHide,
  modalType,
  currentActiveData,
  fetchedGetUsers,
  setCurrentActiveData,
}) => {
  const notification = useToastContext();
  let { user } = useContext(AuthContext);

  // HOOK FORM
  const {
    register,
    setValue,
    clearErrors,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();

  // ALL STATE
  const [profilePic, setProfilePic] = useState("");
  const [profileFile, setProfileFile] = useState("");
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");

  const onSubmit = (data) => {
    const requestPayload = {
      userId: user?._id,
      jobTitle: data?.jobTitle || "",
      companyName: data?.companyName || "",
      jobRole: data?.jobRole || "",
      yearsOfExperience: data?.yearsOfExperience || "",
      salary: data?.salary || "",
      jobLocation: data?.jobLocation || "",
      description: data?.description || "",
      contactNumber: data?.contactNumber || "",
    };
    const userData = { modalTypes: modalType, id: currentActiveData?._id };

    addAndUpdateEmployment(
      requestPayload,
      userData,
      notification,
      (loading, error) => {
        setLoading(loading);
        if (!error) {
          fetchedGetUsers();
          onHide();
        }
      }
    );
  };

  useEffect(() => {
    if (modalType == "edit") {
      setValue("jobTitle", currentActiveData?.jobTitle || "");
      setValue("companyName", currentActiveData?.companyName || "");
      setValue("jobRole", currentActiveData?.jobRole || "");
      setValue("yearsOfExperience", currentActiveData?.yearsOfExperience || "");
      setValue("salary", currentActiveData?.salary || "");
      setValue("jobLocation", currentActiveData?.jobLocation || "");
      setValue("description", currentActiveData?.description || "");
      setValue("contactNumber", currentActiveData?.contactNumber || "");
      setPhone(`+91 ${currentActiveData?.contactNumber}`);
    }
  }, [modalType]);

  return (
    <Modal
      show={show}
      onHide={() => {
        onHide();
        setCurrentActiveData({});
      }}
      centered
    >
      <Modal.Header closeButton className="py-2">
        <Modal.Title className="fw-bold fs-5">Add Job Post</Modal.Title>
      </Modal.Header>
      <Form
        className="common-modal"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        autoComplete="off"
      >
        <Modal.Body className="p-4">
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Job Title</Form.Label>

                <Form.Control
                  type="text"
                  placeholder="Job Title"
                  name="jobTitle"
                  {...register("jobTitle", {
                    required: ValidationMessage.JOB_TITLE_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="jobTitle"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Company Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Company Name"
                  name="companyName"
                  {...register("companyName", {
                    required: ValidationMessage.COMPANY_NAME_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="companyName"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group controlId="formCountryCode">
                <Form.Label className="fw-bold">Contact Number</Form.Label>
                <PhoneInputField
                  register={register}
                  setValue={setValue}
                  errors={errors}
                  name="contactNumber"
                  validationMessage={ValidationMessage}
                  regex={regex}
                  countryCode="+91"
                  initialPhone=""
                  setPhone={setPhone}
                  phone={phone}
                  className={""}
                />
              </Form.Group>
              <ErrorMessage
                errors={errors}
                name="contactNumber"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Job Role</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Job Role"
                  name="jobRole"
                  {...register("jobRole", {
                    required: ValidationMessage.JOB_ROLE_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="jobRole"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Years Of Experience</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Years Of Experience"
                  name="yearsOfExperience"
                  {...register("yearsOfExperience", {
                    required: ValidationMessage.YEAR_OF_EXP_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                  onKeyPress={(e) => integerInput(e)}
                  maxLength={2}
                />
                <ErrorMessage
                  errors={errors}
                  name="yearsOfExperience"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group>
                <Form.Label className="fw-bold">Salary</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Salary"
                  name="salary"
                  {...register("salary", {
                    required: ValidationMessage.SALARY_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                  onKeyPress={(e) => integerInput(e)}
                  maxLength={10}
                />
                <ErrorMessage
                  errors={errors}
                  name="salary"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group>
                <Form.Label className="fw-bold">Job Location</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Job Location"
                  name="jobLocation"
                  {...register("jobLocation", {
                    required: ValidationMessage.JOB_LOCATION_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="jobLocation"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Description</Form.Label>

                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter your description."
                  name="description"
                  {...register("description", {
                    required: ValidationMessage.DESCRIPTION_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                  style={{ resize: "none" }}
                />
                <ErrorMessage
                  errors={errors}
                  name="description"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="primary"
            type="submit"
            className="bg-orange border-0"
            disabled={loading}
            style={loading ? { cursor: "not-allowed" } : { cursor: "pointer" }}
          >
            Submit{" "}
            {loading && (
              <Loader
                style={{
                  marginLeft: "20px",
                }}
                className="loader"
              />
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddEdit;
